<!--<div>-->
  <template>
    <div style="padding: 1em">
    <!--<div class="card-box">-->
      <div class="detail-msg">
        <div class="detail-name"><u>東港金属・本社工場</u></div>
        <div class="card-box-detail">
          <el-row>
            <el-col :span="4"><div class="titleDetail"><span></span></div></el-col>
            <el-col :span="10"><div class="warning">・25:30～26:30は休憩時間のため、受付ができません。</div></el-col>
            <el-col :span="10"><div class="error"><span></span></div></el-col>
          </el-row>
          <el-row>
            <el-col :span="4"><div class="titleDetail"><span></span></div></el-col>
            <el-col :span="10"><div class="warning">・混雑時には、予約時間通りの受付が出来ない場合がございます。</div></el-col>
            <el-col :span="10"><div class="error"><span></span></div></el-col>
          </el-row>
          <el-row>
            <el-col :span="4"><div class="titleDetail"><span>{{systemName}}</span></div></el-col>
            <el-col :span="10"><div class="warning">{{pageInfoMessage}}</div></el-col>
            <el-col :span="10"><div class="error"><span>{{errorMsg}}</span></div></el-col>
          </el-row>
          <el-table
            id="table"
            :data="tableData"
            border
            height="700"
            style="width: 107.6em;margin: 10px 0px 0px 10px;overflow:auto">
            <el-table-column
              prop="id"
              width="50%">
            </el-table-column>
            <el-table-column
              label="搬入日"
              width="175%">
              <template slot-scope="scope">
                <el-date-picker
                  style="width: 90%"
                  v-model="scope.row.Day"
                  type="date"
                  :picker-options="pickerOptions1"
                  :editable="false"
                  placeholder="日付を選択" @change="changeDay(scope.$index, scope)">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              label="時"
              width="130%">
              <template slot-scope="scope">
                <el-select v-model="scope.row.time" placeholder="選択" clearable @change="changeTime(scope.$index, scope)">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="トラック形状"
              width="200%">
              <template slot-scope="scope">
                  <el-select v-model="scope.row.truck" placeholder="選択" clearable @change="changetruck(scope.$index, scope)">
                    <el-option
                      v-for="item in truckList"
                      :key="item.code_id"
                      :label="item.code_name"
                      :value="item.code_id">
                    </el-option>
                  </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="その他"
              width="200%">
              <template slot-scope="scope" v-if="scope.row.truckflg === true || scope.row.truckflg === 'true'">
                <el-input type="textarea" v-model="scope.row.trucktext" placeholder="その他を入力してください。" @change="changetrucktext(scope.$index, scope)"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="品目"
              width="340%">
              <template slot-scope="scope">
                  <el-select v-model="scope.row.item" style="width: 90%" multiple collapse-tags placeholder="選択" clearable @change="changeitem(scope.$index, scope)">
                    <el-option
                      v-for="a in itemList"
                      :key="a.code_id"
                      :label="a.code_name"
                      :value="a.code_id">
                    </el-option>
                  </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="その他"
              width="200%">
              <template slot-scope="scope" v-if="scope.row.itemflg === true || scope.row.itemflg === 'true'">
                <el-input type="textarea" v-model="scope.row.itemtext" placeholder="その他を入力してください。" @change="changeitemtext(scope.$index, scope)"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="備考"
              width="200%">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.prepare " placeholder="備考を入力してください。" @change="changeprepare(scope.$index, scope)"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="text-align: center">
            <el-col :span="24">
              <el-button type="danger" class="kakuninn-btn" :loading="loading" @click.native.prevent="handleSubmit2(tableData)">登　録</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-dialog
        id="informationInputDetail_Dialog"
        title="注意"
        custom-class="informationInputDetail_Dialog closePageDia"
        :visible.sync="waitMessageFlag"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        center>
        <div class="closePageDiv">
          <span>予約処理を実施中、画面が切り替わるまでしばらくお待ちください。</span>
        </div>
      </el-dialog>
    </div>
  </template>
<!--</div>-->
<script>
  import http from '../../assets/js/http'
  import _g from '../../assets/js/global'

  export default {
    data() {
      var checkdate = (rule, value, callback) => {
        if (value == null || value == '') {
          callback(new Error('搬入日時を入力してください。'))
        } else if (!isAdminUserId(value)) {
          callback(new Error('社内のメールアドレスを入力してください。（例：***@tokometal.co.jp|***@trimetals.co.jp）'))
        } else {
          callback()
        }
      }
      return {
        pickerOptions1: {
          disabledDate(time) {
            if (time.getTime() + (3600 * 1000 * 24 * 1) <= Date.now() || time.getTime() - (3600 * 1000 * 24 * 30) >= Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        systemName: '夜間産廃搬入情報入力',
        errorMsg: '',
        oldDate: '',
        value: '',
        pageInfoMessage: '・19時を過ぎている場合、当日の夜間搬入情報を予約できません。',
        clientId: '',
        truckCompName: '',
        loading: false,
        waitMessageFlag: false,
        truckTelSiban: '',
        truckTelKaiban: '',
        truckTelKyoKuBan: '',
        itemList: [],
        truckList: [],
        tableData: [{
          id: '1',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '2',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '3',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '4',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '5',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '6',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '7',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '8',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '9',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }, {
          id: '10',
          day: '',
          dayTime: '',
          time: '',
          truck: [],
          trucktext: '',
          items: [],
          itemtext: '',
          truckNum: '',
          prepare: ''
        }],
        options: [],
        newoptions1: [{
          value: '20',
          label: '20時'
        }, {
          value: '21',
          label: '21時'
        }, {
          value: '22',
          label: '22時'
        }, {
          value: '23',
          label: '23時'
        }, {
          value: '24',
          label: '24時(0時)'
        }, {
          value: '25',
          label: '25時(1時)'
        }, {
          value: '26',
          label: '26時(2時)'
        }, {
          value: '27',
          label: '27時(3時)'
        }, {
          value: '28',
          label: '28時(4時)'
        }, {
          value: '29',
          label: '29時(5時)'
        }, {
          value: '30',
          label: '30時(6時)'
        }, {
          value: '31',
          label: '31時(7時)'
        }, {
          value: '32',
          label: '32時(8時)'
        }],
        newoptions2: [{
          value: '9',
          label: '9時'
        }, {
          value: '10',
          label: '10時'
        }, {
          value: '11',
          label: '11時'
        }, {
          value: '12',
          label: '12時'
        }, {
          value: '13',
          label: '13時'
        }, {
          value: '14',
          label: '14時'
        }, {
          value: '15',
          label: '15時'
        }, {
          value: '16',
          label: '16時'
        }, {
          value: '17',
          label: '17時'
        }, {
          value: '18',
          label: '18時'
        }, {
          value: '19',
          label: '19時'
        }, {
          value: '20',
          label: '20時'
        }, {
          value: '21',
          label: '21時'
        }, {
          value: '22',
          label: '22時'
        }, {
          value: '23',
          label: '23時'
        }, {
          value: '24',
          label: '24時(0時)'
        }, {
          value: '25',
          label: '25時(1時)'
        }, {
          value: '26',
          label: '26時(2時)'
        }, {
          value: '27',
          label: '27時(3時)'
        }, {
          value: '28',
          label: '28時(4時)'
        }, {
          value: '29',
          label: '29時(5時)'
        }, {
          value: '30',
          label: '30時(6時)'
        }, {
          value: '31',
          label: '31時(7時)'
        }, {
          value: '32',
          label: '32時(8時)'
        }],
        rowNum1: 0,
        colNum1: 0,
        trucktextflg: '',
        itemsflg: '',
        itemtextflg: '',
        truckNumflg: ''
      }
    },
    created() {
      this.clientId = this.$route.query.clientId
      this.truckCompName = this.$route.query.truckCompName
      this.truckTelSiban = this.$route.query.truckTelSiban
      this.truckTelKaiban = this.$route.query.truckTelKaiban
      this.truckTelKyoKuBan = this.$route.query.truckTelKyoKuBan
      let data = {}
      data.clientId = window.localStorage.getItem('userId')
      this.apiPost('customer/InformationInput/selectMaster', data).then((res) => {
        this.handelResponse(res, (data) => {
          this.itemList = data.itemList
          this.truckList = data.truckList
        })
      })
      this.apiPost('customer/InformationInput/newDate', data).then((res) => {
        this.handelResponse(res, (data) => {
          this.oldDate = data
        })
      })
      this.options = this.newoptions1

      var sysDate = new Date()
      var month1 = (sysDate.getMonth() + 1) < 10 ? '0' + (sysDate.getMonth() + 1).toString() : (sysDate.getMonth() + 1).toString()
      var day1 = sysDate.getDate() < 10 ? '0' + sysDate.getDate().toString() : sysDate.getDate().toString()
      var day = sysDate.getFullYear().toString() + month1 + day1
      if (parseInt(day) >= 20190810 && parseInt(day) <= 20190818) {
        this.pageInfoMessage = '・19時を過ぎている場合、当日の夜間搬入情報を予約できません。'
      } else {
        this.pageInfoMessage = '・19時を過ぎている場合、当日の夜間搬入情報を予約できません。'
      }
    },
    methods: {
      changeDay(index, scope) {
        if (scope.row.Day !== null) {
          this.tableData[index].Day = scope.row.Day
          var month0 = (scope.row.Day.getMonth() + 1) < 10 ? '0' + (scope.row.Day.getMonth() + 1).toString() : (scope.row.Day.getMonth() + 1).toString()
          var day0 = scope.row.Day.getDate() < 10 ? '0' + scope.row.Day.getDate().toString() : scope.row.Day.getDate().toString()
          var newdate = scope.row.Day.getFullYear().toString() + month0 + day0
          this.tableData[index].dayTime = newdate
          if (parseInt(newdate) >= 20190810 && parseInt(newdate) <= 20190818) {
            this.options = this.newoptions2
          } else {
            this.options = this.newoptions1
          }
        } else {
          this.tableData[index].dayTime = undefined
          this.tableData[index].Day = undefined
          this.options = this.newoptions1
        }
      },
      changeTime(index, scope) {
        if (scope.row.time !== null) {
          this.tableData[index].time = scope.row.time
        }
      },
      changetruck(index, scope) {
        if (scope.row.truck !== null) {
          var truckflg = false
          if (scope.row.truck === '10010' || scope.row.truck === 10010) {
            truckflg = true
          }
          scope.row.truckflg = truckflg
          this.tableData[index].truck = scope.row.truck
        }
      },
      changetrucktext(index, scope) {
        if (scope.row.trucktext !== null) {
          this.tableData[index].trucktext = scope.row.trucktext
        }
      },
      changeitem(index, scope) {
        if (scope.row.item !== null) {
          var itemflg = false
          let data = []
          var a = scope.row.item.forEach(function (item, index, input) {
            data[index] = item
            if (item === '10011' || item === 10011) {
              itemflg = true
            }
          })
          scope.row.itemflg = itemflg
          this.tableData[index].items = data
        }
      },
      changeitemtext(index, scope) {
        if (scope.row.itemtext !== null) {
          this.tableData[index].itemtext = scope.row.itemtext
        }
      },
      changeprepare(index, scope) {
        if (scope.row.prepare !== null) {
          this.tableData[index].prepare = scope.row.prepare
        }
      },
      handleSubmit2(tableData) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        var sysDate = new Date()
        var month0 = (sysDate.getMonth() + 1) < 10 ? '0' + (sysDate.getMonth() + 1).toString() : (sysDate.getMonth() + 1).toString()
        var day0 = sysDate.getDate() < 10 ? '0' + sysDate.getDate().toString() : sysDate.getDate().toString()
        var day = sysDate.getFullYear().toString() + month0 + day0
        var hms = sysDate.getHours().toString()
        var table = ''
        var rows = ''
        var cells = ''
        var div = ''
        if (this.rowNum1 !== 0 && this.colNum1 !== 0) {
          table = document.getElementById('table')
          rows = table.getElementsByTagName('tr')
          cells = rows[this.rowNum1].getElementsByTagName('td')
          div = cells[this.colNum1].getElementsByTagName('div')
          div[1].style.border = '0px'
          this.errorMsg = ''
        }
        var rowNum = 0
        var colNum = 0
        var error = ''
        var dataFlg = false

        this.tableData.forEach(function (item, index, input) {
          if ((item.Day !== undefined && item.Day !== null) ||
            item.time !== '' ||
            item.truck !== '' ||
            item.trucktext !== '' ||
            item.items.length !== 0 ||
            item.itemtext !== '' ||
            item.truckNum !== '' ||
            item.prepare !== '') {
            dataFlg = true
            if (item.Day === undefined) {
              _g.toastMsg('error', '搬入日時を選択してください。')
              error = '搬入日時を選択してください。'
              rowNum = item.id
              colNum = 1
              return
            } else {
              console.log('item.dayTime', item.dayTime)
              console.log('day', day)
              if (item.dayTime === day) {
                // if (parseInt(day) >= 20190810 && parseInt(day) <= 20190818) {
                //   if (hms >= 17) {
                //     _g.toastMsg('error', '17時を過ぎたので、予約できません。')
                //     error = '17時を過ぎたので、予約できません。'
                //     rowNum = item.id
                //     colNum = 1
                //     return
                //   }
                // } else {
                console.log('hms', parseInt(hms))
                if (hms >= 19) {
                  _g.toastMsg('error', '19時を過ぎたので、予約できません。')
                  error = '19時を過ぎたので、予約できません。'
                  rowNum = item.id
                  colNum = 1
                  return
                }
                // }
              }
            }
            if (item.time === '') {
              _g.toastMsg('error', '時を選択してください。')
              error = '時を選択してください。'
              rowNum = item.id
              colNum = 2
              return
            }
            if (item.truck === '') {
              _g.toastMsg('error', 'トラック形状を選択してください。')
              error = 'トラック形状を選択してください。'
              rowNum = item.id
              colNum = 3
              return
            }
            if (item.items.length === 0) {
              _g.toastMsg('error', '品目を選択してください。')
              error = '品目を選択してください。'
              rowNum = item.id
              colNum = 5
              return
            }
            if (item.truck !== '') {
              var truckflg = false
              if (item.truck === '10010' || item.truck === 10010) {
                truckflg = true
              }
              if (truckflg && item.trucktext === '') {
                _g.toastMsg('error', 'トラック形状のその他を入力してください。')
                error = 'トラック形状のその他を入力してください。'
                rowNum = item.id
                colNum = 4
                return
              } else {
                if (item.trucktext.length > 20) {
                  _g.toastMsg('error', 'トラック形状のその他は20文字以下を入力してください。')
                  error = 'トラック形状のその他は20文字以下を入力してください。'
                  rowNum = item.id
                  colNum = 4
                  return
                }
              }
            }
            if (item.item.length !== 0) {
              var itemflg = false
              var b = item.item.forEach(function (item3, index3, input3) {
                if (item3 === '10011' || item3 === 10011) {
                  itemflg = true
                }
              })
              if (itemflg && item.itemtext === '') {
                _g.toastMsg('error', '品目のその他を入力してください。')
                error = '品目のその他を入力してください。'
                rowNum = item.id
                colNum = 6
                return
              } else {
                if (item.trucktext.length > 20) {
                  _g.toastMsg('error', '品目のその他は20文字以下を入力してください。')
                  error = '品目のその他は20文字以下を入力してください。'
                  rowNum = item.id
                  colNum = 6
                  return
                }
              }
            }
            if (item.prepare !== '') {
              if (item.prepare.length > 50) {
                _g.toastMsg('error', '備考は50文字以下を入力してください。')
                error = '備考は50文字以下を入力してください。'
                rowNum = item.id
                colNum = 7
              }
            }
          }
        })
        var errorFlg = false
        if (rowNum !== 0 && colNum !== 0) {
          table = document.getElementById('table')
          rows = table.getElementsByTagName('tr')
          cells = rows[rowNum].getElementsByTagName('td')
          div = cells[colNum].getElementsByTagName('div')
          div[1].style.border = '1px solid #f56c6c'
          this.errorMsg = error
          this.rowNum1 = rowNum
          this.colNum1 = colNum
          errorFlg = true
        }
        if (dataFlg === false) {
          this.loading = false
          _g.toastMsg('error', '追加データがありません。')
          return
        }
        if (!errorFlg) {
          this.waitMessageFlag = true
          let data = {}
          this.loading = true
          data.dataList = this.tableData
          data.clientId = window.localStorage.getItem('userId')
          data.truckCompName = this.truckCompName
          data.truckTelSiban = this.truckTelSiban
          data.truckTelKaiban = this.truckTelKaiban
          data.truckTelKyoKuBan = this.truckTelKyoKuBan
          this.apiPost('customer/InformationInput/saveDetail', data).then((res) => {
            this.handelResponse(res, (data) => {
              this.loading = false
              if (res.code != 200) {
                this.handleError(res)
              } else {
                _g.toastMsg('success', 'データを更新しました！')
              }
              if (res.data != null && res.data !== '') {
                this.waitMessageFlag = false
                var userId = window.localStorage.getItem('userId')
                this.$router.push({ path: '/customer/informationInputShow', query: { oldDate: this.oldDate, userId: userId, truckTelSiban: this.truckTelSiban, truckTelKaiban: this.truckTelKaiban, truckTelKyoKuBan: this.truckTelKyoKuBan, reservedId: data, errorMsg: res.error }})
              }
            })
          })
        }
      }
    },
    mixins: [http]
  }
</script>
<style>
  .card-box-detail {
    padding: 0.1em;
  }
  .detail-msg {
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 0.1em auto;
    height: 59em;
    width: 96em;
    border: 0.1em solid #8492A6;
  }
  .kakuninn-btn{
    margin-top: 1.5em;
    margin-bottom: 1em;
    width: 10em;
  }
  .el-table__body tr{
    height:80px;
  }
  .titleDetail {
    color: #505458;
    font-weight: bold;
    font-size: 1.17em;
    padding: 0em 0em 0.1em 0.5em;
  }
  .detail-name{
    text-align: right;
    padding: 0.5em;
    font-weight: bold;
    font-size: 1.3em;
  }
  .error {
    color: #f56c6c;
  }
  .warning {
    color: #f56c6c;
  }
  .closePageDia
  {
    width: 459px;
  }
  #informationInputDetail_Dialog .el-dialog{
    display: flex;
    flex-direction: column;
    margin:0 !important;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    max-height:calc(100% - 30px);
    max-width:calc(100% - 30px);
  }
  #informationInputDetail_Dialog .el-dialog .el-dialog__body{
    flex:1;
    overflow: auto;
  }
  .informationInputDetail_Dialog .el-dialog__headerbtn .el-dialog__close {
    color: #464646;
    font: Bold 23px/34px Meiryo;
  }
  .informationInputDetail_Dialog .el-dialog__headerbtn {
    top: 10px;
  }
  .informationInputDetail_Dialog .el-dialog__header {
    text-align: center;
    padding-top: 12px;
    padding-bottom: 11px;
    border: 1px solid #D8D8D8;
    font: Bold 18px/27px Meiryo;
    letter-spacing: 0;
    color: #464646;
    opacity: 1;
    border-radius: 5px 5px 0 0;
  }
  .informationInputDetail_Dialog .label-title
  {
    text-align: left;
    font: Bold 13px/20px Meiryo;
    letter-spacing: 0;
    color: #464646;
    opacity: 1;
    margin-bottom: 4px;
  }
  .informationInputDetail_Dialog .is-Redtext{
    margin: 0 0.5rem;
    display: inline-block;
    color: white;
    text-align: center;
    font: Bold 10px/15px Meiryo;
    width: 2rem;
    background: #FF9100 0 0 no-repeat padding-box;
    opacity: 1;
  }
  .informationInputDetail_Dialog .formLine {
    margin-bottom: 1rem;
  }
</style>
<!--<style>-->
  <!--.el-table__body .el-date-editor.el-input, .el-date-editor.el-input__inner {-->
    <!--width: 180px;-->
  <!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/customer/informationInputDetail.vue